import { type GroupedShiftCounts, type ShiftCardData, type TimeSlotCounts } from "../types";

interface GroupedShifts {
  am: ShiftCardData[];
  pm: ShiftCardData[];
  noc: ShiftCardData[];
}

/**
 * Groups shift cards by time slot (AM, PM, NOC)
 */
export function groupShiftsByTimeSlot(shifts: ShiftCardData[]): GroupedShifts {
  const am: ShiftCardData[] = [];
  const pm: ShiftCardData[] = [];
  const noc: ShiftCardData[] = [];

  for (const shift of shifts) {
    switch (shift.timeSlot) {
      case "am": {
        am.push(shift);
        break;
      }

      case "pm": {
        pm.push(shift);
        break;
      }

      case "noc": {
        noc.push(shift);
        break;
      }

      default: {
        // Unknown time slot, skip
        break;
      }
    }
  }

  return { am, pm, noc };
}

/**
 * Calculates counts for a single time slot
 */
export function calculateTimeSlotCounts(shifts: ShiftCardData[]): TimeSlotCounts {
  let filledShiftsCount = 0;
  let unfilledShiftsCount = 0;

  for (const shift of shifts) {
    if (shift.workerId) {
      filledShiftsCount += 1;
    } else {
      unfilledShiftsCount += 1;
    }
  }

  // Note: warningShiftsCount not currently implemented
  return { filledShiftsCount, unfilledShiftsCount, warningShiftsCount: 0 };
}

/**
 * Calculates counts from grouped shifts
 */
export function calculateCountsFromShifts(groupedShifts: GroupedShifts): GroupedShiftCounts {
  return {
    am: calculateTimeSlotCounts(groupedShifts.am),
    pm: calculateTimeSlotCounts(groupedShifts.pm),
    noc: calculateTimeSlotCounts(groupedShifts.noc),
  };
}
